import { cloneElement } from 'react';
import type { ReactElement } from 'react';

import { useTheme } from '@emotion/react';

import { useIsMobile } from '@twistopayments/design-system/hooks';
import { CheckmarkOutlineIcon, CloseIcon, InfoIcon, WarningOutlineIcon } from '@twistopayments/design-system/icons/inline';

import { Typography } from '../typography';

import * as styles from './toast-message.styles';
import type { Message, ToastVariant } from './toast.context';

const iconsMap: Record<ToastVariant, ReactElement> = {
  success: <CheckmarkOutlineIcon color="primary" />,
  warning: <WarningOutlineIcon color="warning" />,
  error: <WarningOutlineIcon color="error" />,
  info: <InfoIcon color="gray" />,
};

type Props = {
  message: Message;
  variant: ToastVariant;
  onClose: () => void;
};

export const ToastMessage = ({ message, variant, onClose }: Props) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const icon = cloneElement(iconsMap[variant], {
    size: isMobile ? '24' : '32',
  });

  return (
    <div css={[styles.variants[variant](theme), styles.box(theme)]} data-testid="toast-message">
      {icon}

      <Typography color="textPrimary" variant="b2">
        {message}
      </Typography>

      <button
        css={styles.button(theme)}
        onClick={(event) => {
          event.preventDefault();
          onClose();
        }}>
        <CloseIcon color="gray" size="16" />
      </button>
    </div>
  );
};
